import React from 'react';
import logo from '../../assets/logo/logo.svg';
import { FcHome } from 'react-icons/fc';
import { FcFeedback } from 'react-icons/fc';
import { FcCellPhone } from 'react-icons/fc';
import { BsFacebook } from 'react-icons/bs';
import { AiFillTwitterCircle } from 'react-icons/ai';
import { TiSocialInstagramCircular } from 'react-icons/ti';
import { TiSocialLinkedinCircular } from 'react-icons/ti';
import { BsGithub } from 'react-icons/bs';
import { BsStackOverflow } from 'react-icons/bs';
import { FaDev } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-to-top';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <footer className="bg-secondary">
            <ScrollToTop
                className="flex justify-center items-center"
                smooth
                top={600}
                width="15"
                color="#FD4370"
                style={{
                    background: 'transparent',
                    borderRadius: '30px',
                    border: '1px solid #FD4370',
                    margin: '0px -30px -30px 0px',
                    padding: '0px',
                }}
            />
            <div className="flex justify-between items-start flex-wrap px-4 lg:px-60 md:px-32 py-10">
                {/* ===========address, mail, number=========== */}
                <div>
                    <img width={180} src={logo} alt="logo" />
                    <div className="leading-8">
                        <p className="flex items-center">
                            <FcHome size={20} className="mr-1"></FcHome>
                            Tangail, Dhaka, Bangladesh
                        </p>
                        <p className="flex items-center">
                            <FcFeedback size={20} className="mr-1"></FcFeedback>
                            palakxdev@gmail.com
                        </p>
                        <p className="flex items-center">
                            <FcCellPhone size={25}></FcCellPhone> +880
                            1795-225530
                        </p>
                    </div>
                </div>
                {/* ==========quick links========== */}
                <div className="mt-4 lg:mt-0">
                    <h2 className="text-3xl text-accent font-bold mb-2">
                        Quick Links
                    </h2>
                    <ul className="leading-8">
                        <li className="rounded-box hover:text-accent">
                            <HashLink smooth to="home#home">
                                Home
                            </HashLink>
                        </li>
                        <li className="rounded-box hover:text-accent">
                            <Link to="about">About</Link>
                        </li>
                        <li className="rounded-box hover:text-accent">
                            <HashLink smooth to="home#skills">
                                Skills
                            </HashLink>
                        </li>
                        <li className="rounded-box hover:text-accent">
                            <HashLink smooth to="home#experience">
                                Experience
                            </HashLink>
                        </li>
                        <li className="rounded-box hover:text-accent">
                            <HashLink smooth to="home#portfolio">
                                Portfolio
                            </HashLink>
                        </li>
                        <li className="rounded-box hover:text-accent">
                            <HashLink smooth to="home#contact">
                                Contact
                            </HashLink>
                        </li>
                    </ul>
                </div>
                {/* ==========social media========== */}
                <div className="mt-4 lg:mt-0">
                    <h2 className="text-3xl text-accent font-bold mb-2">
                        Social Media
                    </h2>
                    <div className="flex items-center flex-wrap">
                        <a
                            href="https://www.facebook.com/palakxdev/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <BsFacebook
                                size={25}
                                className="mr-2 hover:text-accent"
                            ></BsFacebook>
                        </a>

                        <a
                            href="https://twitter.com/palakxdev"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <AiFillTwitterCircle
                                size={29}
                                className="mr-2 hover:text-accent"
                            ></AiFillTwitterCircle>
                        </a>

                        <a
                            href="https://www.instagram.com/palakxdev/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <TiSocialInstagramCircular
                                size={32}
                                className="mr-2 hover:text-accent"
                            ></TiSocialInstagramCircular>
                        </a>

                        <a
                            href="https://www.linkedin.com/in/palakxdev"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <TiSocialLinkedinCircular
                                size={33}
                                className="mr-2 hover:text-accent"
                            ></TiSocialLinkedinCircular>
                        </a>

                        <a
                            href="https://github.com/palakxdev/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <BsGithub
                                size={25}
                                className="mr-2 hover:text-accent"
                            ></BsGithub>
                        </a>

                        <a
                            href="https://stackoverflow.com/users/20894866/palakxdev"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <BsStackOverflow
                                size={25}
                                className="mr-2 hover:text-accent"
                            ></BsStackOverflow>
                        </a>

                        <a
                            href="https://dev.to/palakxdev"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FaDev
                                size={25}
                                className="mr-2 hover:text-accent mt-2 lg:mt-0"
                            ></FaDev>
                        </a>
                    </div>

                    {/* ================COPY RIGHT================ */}
                    <div className=" mt-3">
                        <p>
                            <span className="text-accent">PALAK SARKER</span>{' '}
                            &copy; {new Date().getFullYear()} all rights
                            reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
